<template>
	<div class="col-lg-8">
		<div class="activity-list ">
			<div class="activity-item text-block">
				<div v-if="authorized">
					<p>Для отправки обращения, которое может служить основанием для проведения внеплановой проверки,
						необходимо
						войти в Интернет-приемную администрации города Перми (сайт на котором Вы сейчас находитесь) через
						портал "Госуслуг" (ЕСИА).</p>

					<p>При использовании личного кабинета Интернет-приемной администрации города Перми, вход в который
						произведен через имя и пароль (а не черезе ЕСИА), требуется выйти из личного кабинета и
						зарегистрироваться
						заново с использованием ЕСИА.</p>

					<p>
						<a :href="logoutUrl" @click.stop="logout" style="font-weight:16px;">
							<button>Выйти и зарегистрироваться.</button>
						</a>
					</p>
					<br>
				</div>

				<p>После авторизации на портале "Госуслуги", Вам будет предложено предоставить Интернет приёмной следующие
					данные Вашего профиля:</p>

				<ul style="padding-left: 50px;">
					<li>адрес Вашей электронной почты</li>
					<li>номер Вашего мобильного телефона</li>
					<li>Вашу фамилию, имя и отчество</li>
				</ul>

				<p>Если Вы разрешите предоставить Интернет-приёмной запрашиваемые данные, авторизация будет считаться
					успешной, если нет, то авторизация будет считаться не пройденной.</p>

				<p v-if="!authorized">
					<a :href="redirectUrl" style="font-weight:16px;"><button>Войти через портал
							Госуслуги</button></a>
				</p>

			</div>
		</div>
	</div>
</template>

<script>

import { getRedirectUrl, authorized, authorizedThroughEsia, deleteTokens, getLogoutUrl } from '@/auth';

export default {
	data() {
		return {
			redirectUrl: null,
			authorized: false,
			logoutUrl: null
		}
	},
	async created() {
		if (authorizedThroughEsia()) {
			this.$router.push('/send');
		}
		this.logoutUrl = getLogoutUrl('/esia-redirect');

		this.authorized = authorized();

		let redirectUrl = new URL(await getRedirectUrl(), window.location.origin);
		redirectUrl.searchParams.append('kc_idp_hint', 'esia-provider');
		this.redirectUrl = redirectUrl.toString();
	},
	methods: {
		logout: function () {
			deleteTokens();
			// window.location.href = this.logoutUrl;
		},
	},

}

</script>